import { Navigate, useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Brand } from "../components/Layout";
import { Loading } from "../components/kit";

export default function SelectStore() {
  const { user, stores, setStoreId } = useAuth();
  const navigate = useNavigate();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <div className="bs-navy-panel h-16 px-6 flex items-center"><Brand /></div>
      <div className="max-w-xl mx-auto px-5 py-12 bs-rise">
        <h1 className="font-display text-4xl font-bold text-[#011E38]">Choose a store</h1>
        <p className="text-slate-500 mt-2 mb-8">You manage {stores.length} stores. You can switch anytime from the header.</p>
        <div className="space-y-3">
          {stores.map((s) => (
            <button key={s.id} onClick={() => { setStoreId(s.id); navigate("/dashboard"); }} data-testid={`select-store-${s.id}`}
              className="bs-card w-full p-6 flex items-center justify-between text-left hover:border-[#011E38] transition-colors">
              <div>
                <div className="font-display text-xl font-semibold text-[#011E38]">{s.name}</div>
                <div className="text-sm text-slate-500">{[s.city, s.region].filter(Boolean).join(" · ")}</div>
              </div>
              <ChevronRight className="text-slate-400" />
            </button>
          ))}
          {!stores.length && <p className="text-slate-500">No stores assigned yet. Contact your admin.</p>}
        </div>
      </div>
    </div>
  );
}
